import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// Loads PostHog if a key is configured, and does nothing at all if not.
import { initAnalytics } from "./utils/analytics";
import { Bounce, ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Route, Routes, useParams } from "react-router-dom";
import { store } from './store/store'
import { Provider } from 'react-redux'
import './utils/api';
import { NavigationGuardProvider } from './contexts/NavigationGuardContext';


// Before React renders, so the first event of the funnel is not missed.
initAnalytics();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ToastContainer position="bottom-center" transition={Bounce}/>
      <Router>
        <NavigationGuardProvider> 
        <App />
        </NavigationGuardProvider> 
      </Router>
    </Provider>
  </React.StrictMode>
);
